export class Flight {
    constructor() {
        this.endpoint = 'flight'
        this.boot = [{ index : [
            () => {
            }
        ]}]
    }
}